// List of routes no longer internationalized
// More keys can be added using the | operator eg `RouteKey.Checkout | RouteKey.Search`
export type DeprecatedRouteKeys = RouteKey.Checkout | RouteKey.Search;

export enum RouteKey {
  Basket,
  Wishlist,
  /**
   * @deprecated Search route is no longer internationalized - use /search
   */
  Search,
  Brands,
  Imprint,
  /**
   * @deprecated Checkout route is no longer internationalized - use /checkout
   */
  Checkout,
  YourShop,
}
